import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Inscription, Preloader, RoundPendingIcon, useResponsive } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

interface Props {
  isDeactivating: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeactivateAuthorizedUserModal = ({ isDeactivating, onConfirm, onClose }: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <ModalWrapper visible onSetVisible={onClose} testId="deactivate-authorized-user-modal">
      <Box align="center" pad={{ vertical: 'spacing24' }}>
        <RoundPendingIcon color="warning" />
        <Inscription margin={{ top: 'spacing12' }} size={isMobile ? 'xxlarge' : '2xl'} weight={700}>
          {t('Deactivate authorized user?')}
        </Inscription>
        <Box margin={{ top: 'spacing24' }} direction={isMobile ? 'column-reverse' : 'row'} gap="spacing12" fill={isMobile ? 'horizontal' : undefined}>
          <AppButton
            buttonType="secondary"
            width={isMobile ? '100%' : '140px'}
            testId="deactivate-authorized-user-modal_cancel"
            onClick={onClose}
          >
            {t('Cancel')}
          </AppButton>
          <AppButton
            color="red"
            width={isMobile ? '100%' : '140px'}
            testId="deactivate-authorized-user-modal_confirm"
            onClick={onConfirm}
          >
            {isDeactivating ? (
              <Preloader testId="deactivate-authorized-user-modal_confirm-preloader" color="error" />
            ) : (
              t('Deactivate')
            )}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default DeactivateAuthorizedUserModal;
